import { Model } from "@westpierstudio/luma/mvc";
import { IServiceProvider } from "@westpierstudio/luma/services";
import { SpinType } from "components/reels/ReelsModel";
import { cloneDeep, orderBy } from "lodash";
import { MultipliedWinsMap, PayLineWin } from "servertypes/SharedTypes";

export interface WinDisplayConfig {
    displayWinTime: number,
    timeBetweenWins: number
}

export class WinlinesModel extends Model {
    private _activeWinDisplayConfig!: WinDisplayConfig;
    private winDisplayConfigs: Map<SpinType, WinDisplayConfig> = new Map();
    private wins: PayLineWin[] = [];
    private lineIndex = 0;
    lineCount = 0;

    constructor(services: IServiceProvider) {
        super(services);

        this.setupWinDisplayConfigs();
    }

    get activeWinDisplayConfig(): WinDisplayConfig {
        return this._activeWinDisplayConfig;
    }

    setWinDisplayConfigForSpinType(type: SpinType): WinDisplayConfig {

        this._activeWinDisplayConfig = this.winDisplayConfigs.get(type) as WinDisplayConfig;
        return this._activeWinDisplayConfig;
    }

    storeWins(wins: PayLineWin[], multipliedWinsMap: MultipliedWinsMap): void {

        if (wins.length > 0) {

            this.wins = cloneDeep(wins);

            for (const [i, item] of this.wins.entries()) {

                if (multipliedWinsMap[i]) {
                    item.moneyWon = multipliedWinsMap[i].multipliedMoneyWon;
                }
            }

            this.wins = orderBy(this.wins, [`moneyWon`, `paylineIndex`], [`desc`, `asc`]);
            this.lineIndex = 0;
            this.lineCount = wins.length;
        } else {
            this.wins = [];
        }
    }

    nextWinLineData(): PayLineWin | undefined {

        if (!this.wins || this.lineIndex === this.lineCount) {
            return;
        }

        return this.wins[this.lineIndex++];
    }

    resetLineIndex(): void {
        this.lineIndex = 0;
    }

    override reset(): void {

        this.wins = [];
        this.lineIndex = 0;
        this.lineCount = 0;
    }

    private setupWinDisplayConfigs(): void {

        const configs: Record<SpinType, WinDisplayConfig> = this.services.resources.getSetting(`winDisplayConfigs`);

        for (const [key, value] of Object.entries(configs)) {

            switch(key) {
                case SpinType.REGULAR:
                    this.winDisplayConfigs.set(key, value);
                    break;
                case SpinType.FREE_SPIN:
                case SpinType.TURBO:
                case SpinType.TURBO_FREE_SPIN:
                    this.winDisplayConfigs.set(key, this.makeCustomWinDisplayConfig(configs[SpinType.REGULAR], value));
                    break;
            }
        }
    }

    private makeCustomWinDisplayConfig(defaultValues: Record<string,any>, customValues: Record<string,any>): WinDisplayConfig {

        const customConfig = cloneDeep(defaultValues);

        for (const [key, value] of Object.entries(customValues)) {
            customConfig[key] = value;
        }

        return customConfig as WinDisplayConfig;
    }
}